(() => {
  // app/scripts/coveo-search-variants.js
  var CoveoSearchVariants = class {
    constructor() {
      this.isExecuting = false;
      this.resolve = null;
      this.init();
    }
    async init() {
      const { buildSearch, loadQueryActions, loadSearchActions } = window.coveoheadless;
      const searchToken = await CoveoUtils.getSearchToken();
      if (!searchToken) {
        return;
      }
      this.engine = window.configureHeadless(searchToken);
      this.search = buildSearch(this.engine);
      this.queryActions = loadQueryActions(this.engine);
      this.searchActions = loadSearchActions(this.engine);
      this.search.subscribe(() => {
        if (this.search.state.isLoading) {
          return;
        }
        if (this.isExecuting) {
          this.isExecuting = false;
          this.resolve?.(this.search.state.products);
        }
      });
    }
    executeQuery(query) {
      const {
        engine: { dispatch },
        queryActions,
        searchActions
      } = this;
      this.isExecuting = true;
      dispatch(queryActions.updateQuery({ query }));
      dispatch(searchActions.executeSearch());
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    }
  };
  window.CoveoSearchVariants = new CoveoSearchVariants();
})();
